import { ICON_COLOR } from '@/constants/icons';
import { FunctionItem, ProjectFunction } from '@/types';
import { getIcon } from '@/utils/imageUtils';

export const FunctionsData: Record<ProjectFunction, FunctionItem> = {
  [ProjectFunction.PLANNED]: {
    name: ProjectFunction.PLANNED,
    labelEn: 'Planned',
    labelPt: 'Planeado',
    icon: getIcon(
      `${ProjectFunction.PLANNED}_ico-${ICON_COLOR}.svg`,
      'functions',
      ProjectFunction.PLANNED,
    ),
    descEn: 'Definition of project scope, goals, and initial architecture to ensure a structured workflow.',
    descPt: 'Definição do âmbito, objetivos e arquitetura inicial do projeto para garantir um fluxo de trabalho estruturado.',
  },
  [ProjectFunction.DESIGNED]: {
    name: ProjectFunction.DESIGNED,
    labelEn: 'Designed',
    labelPt: 'Desenhado',
    icon: getIcon(
      `${ProjectFunction.DESIGNED}_ico-${ICON_COLOR}.svg`,
      'functions',
      ProjectFunction.DESIGNED,
    ),
    descEn: 'Creation of wireframes, prototypes, and UI/UX layouts to establish a cohesive design.',
    descPt: 'Criação de wireframes, protótipos e layouts de UI/UX para estabelecer um design coeso.',
  },
  [ProjectFunction.DEVELOPED]: {
    name: ProjectFunction.DEVELOPED,
    labelEn: 'Developed',
    labelPt: 'Desenvolvido',
    icon: getIcon(
      `${ProjectFunction.DEVELOPED}_ico-${ICON_COLOR}.svg`,
      'functions',
      ProjectFunction.DEVELOPED,
    ),
    descEn: 'Development and structuring of core functionalities and features.',
    descPt: 'Desenvolvimento e estruturação das funcionalidades principais.',
  },
  [ProjectFunction.IMPLEMENTED]: {
    name: ProjectFunction.IMPLEMENTED,
    labelEn: 'Implemented',
    labelPt: 'Implementado',
    icon: getIcon(
      `${ProjectFunction.IMPLEMENTED}_ico-${ICON_COLOR}.svg`,
      'functions',
      ProjectFunction.IMPLEMENTED,
    ),
    descEn: 'Integration features, APIs, and third-party services to enhance application capabilities.',
    descPt: 'Integração de funcionalidades, APIs e serviços de terceiros para ampliar as capacidades da aplicação.',
  },
  [ProjectFunction.OPTIMIZED]: {
    name: ProjectFunction.OPTIMIZED,
    labelEn: 'Optimized',
    labelPt: 'Optimizado',
    icon: getIcon(
      `${ProjectFunction.OPTIMIZED}_ico-${ICON_COLOR}.svg`,
      'functions',
      ProjectFunction.OPTIMIZED,
    ),
    descEn: 'Code optimization, performance improvement, and maintainability.',
    descPt: 'Otimização de código, melhoria de desempenho e manutenibilidade.',
  },
  [ProjectFunction.DEPLOYED]: {
    name: ProjectFunction.DEPLOYED,
    labelEn: 'Deployed',
    labelPt: 'Lançado',
    icon: getIcon(
      `${ProjectFunction.DEPLOYED}_ico-${ICON_COLOR}.svg`,
      'functions',
      ProjectFunction.DEPLOYED,
    ),
    descEn: 'Deployment of the project to production.',
    descPt: 'Lançamento do projeto para produção.',
  },
};
